<div class="camera-container">
	<video #cameraVid id="video" [style.display]="isVideoing ? 'block' : 'none'">Video stream not available.</video>
	<canvas #cameraCanvas id="canvas" [style.display]="isVideoing ? 'none' : 'block'"></canvas>
	<img class='take-pic-button' src="/assets/camera.png" [style.display]="isVideoing ? 'block' : 'none'" (click)="takePhoto()">
	<img class='redo-button' src="/assets/redo.png" [style.display]="isVideoing ? 'none' : 'block'" (click)="redoPhoto()">
</div>